import constants from '../qti/Constants';
import settingsReader from '../store/readHelpers/SettingsReader';

// Known postfixes for drawing-related response identifiers
export const DRAWING_POSTFIXES = [
    '_jsonId',
    '_fileName',
    '_fileType',
    '_fileSize',
    '_drawingBase64',
    '_jsonData',
    '_pendingSync',
    '_fileURI',
    '_jsonDataURI',
];

// Checks if an identifier is a drawing response identifier.
export default function isDrawingResponseIdentifier(identifier) {
    if (typeof identifier !== 'string') {
        return false;
    }
    return DRAWING_POSTFIXES.some(postfix => identifier.endsWith(postfix));
}

// Checks if drawing is enabled for preloading purposes.
export function isDrawingEnabledForPreloading(question) {
    if (!settingsReader.isCandidateDrawingOptionEnabled()) {
        return false;
    }

    if (question?.responseModels?.some(model => model.type === constants.interactionType.DRAWING_INTERACTION)) {
        return true;
    }

    if (question?.itemBody?.includes('<drawingInteraction')) {
        return true;
    }

    return false;
}

// Determines if an offline data value should be cleared when serializing item results.
export function shouldClearOfflineDataValue(identifier, includeOfflineData) {
    if (includeOfflineData) {
        return false;
    }
    if (typeof identifier !== 'string') {
        return false;
    }
    return identifier.endsWith('_drawingBase64') || identifier.endsWith('_jsonData') || identifier.endsWith('_pendingSync');
}
